import { createAsyncThunk } from "@reduxjs/toolkit";
import { createChat, createChatAdmin, createChatRider, getChatOrder, getChatProducts,  getChatVouchers,  getProducts as getProductsApi,} from "helpers/backend_helper";

export const createChatConfig = createAsyncThunk(
  "chat/createChatConfig",
  async (formData: any) => {
    try {
      const response = await createChat(formData); // <-- yeh sahi call hai
      return response;
    } catch (error) {
      return {
        isSuccess: false,
        message: "Please! fill out the complete form",
      };
    }
  }
);

export const chatOrder = createAsyncThunk(
  "order/chatOrder",
  async (
    { userId }: {  userId: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await getChatOrder( userId);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const chatVoucher = createAsyncThunk(
  "order/chatVoucher",
  async (
    { userId }: {  userId: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await getChatVouchers( userId);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const createChatRiderThunk = createAsyncThunk(
  'chat/createChatRider',
  async (data: any, thunkAPI) => {
    try {
      const response = await createChatRider(data);
      return response.data; 
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createChatAdminThunk = createAsyncThunk(
  'chat/createChatAdmin',
  async (data: any, thunkAPI) => {
    try {
      const response = await createChatAdmin(data);
      return response.data; 
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const chatProduct = createAsyncThunk(
  "product/get",
  async ({ page, count, status, keyword, }: { page: number, count: number, status: string; keyword: string }) => {
    try {
      const response = await getProductsApi(page, count, status, keyword);
      return response.data;
    } catch (error) {
      throw error; // Rethrow the error for proper handling
    }
  }
);

